import { useRef, useEffect } from 'react';
import { Input, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import CustomFilterCollapse from '@src/components/CustomFilterCollapse';
import PropTypes from 'prop-types';
import { Text } from '@src/components';

const FilterMenu = ({ setFilteredText, filteredText, clickFilter, clearFilter, panels, listenClickCheckbox }) => {

  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [filteredText]);

  const onInputChange = (e) => {
    const value = e.target.value;
    setFilteredText(value);
  };
  return (
    <div className="custom-filter-menu">
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <span className="custom-filter-menu-filtrele"><Text t="filter2" /></span>
        <button onClick={clearFilter} className="custom-filter-menu-clear">
          <Text t="clean" /></button>
      </div>
      <div>
        <div style={{
          color: '#00a483',
          fontFamily: 'UbuntuMedium'
        }}><Text t="deliveryAddress2" /></div>
        <Input
          ref={inputRef}
          id="demandsFilterSearch"
          name="demandsFilterSearch"
          type="text"
          placeholder="Ara"
          prefix={<SearchOutlined />}
          className="custom-filter-menu-search no-margin"
          value={filteredText}
          onChange={onInputChange}
        />
      </div>

      <CustomFilterCollapse panels={panels} listenClickCheckbox={listenClickCheckbox} />

      <Button
        type="primary"
        onClick={clickFilter}
        block
        className="custom-filter-menu-filter-button"
      >
        <Text t="filter2" />
      </Button>
    </div>
  );
};

export default FilterMenu;

FilterMenu.propTypes = {
  setFilteredText: PropTypes.any,
  filteredText: PropTypes.string,
  clickFilter: PropTypes.func,
  clearFilter: PropTypes.func,
  panels: PropTypes.array,
  listenClickCheckbox: PropTypes.any,
};